var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabInmobiliario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 578.493,
    height: 578.493,
    viewBox: "0 0 578.493 578.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2396",
    "data-name": "Group 2396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2395",
    "data-name": "Group 2395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M399.071,477.867H129.108a9.645,9.645,0,0,0-9.641,9.641v19.284a9.641,9.641,0,0,0,19.282,0v-9.641H399.071a9.642,9.642,0,0,0,0-19.284Z",
    transform: "translate(15.515 62.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5170",
    "data-name": "Path 5170",
    d: "M187.733,221.091a9.645,9.645,0,0,0,9.641,9.641h38.567a9.645,9.645,0,0,0,9.641-9.641V163.241a9.645,9.645,0,0,0-9.641-9.641H197.375a9.645,9.645,0,0,0-9.641,9.641v57.849Zm19.283-48.207H226.3v38.566H207.016Z",
    transform: "translate(24.381 19.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5171",
    "data-name": "Path 5171",
    d: "M125.34,102.4H9.641A9.645,9.645,0,0,0,0,112.041V304.873a9.641,9.641,0,0,0,19.282,0V121.684H125.34a9.642,9.642,0,0,0,0-19.284Z",
    transform: "translate(0 13.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5172",
    "data-name": "Path 5172",
    d: "M409.6,425.89a9.646,9.646,0,0,0,9.642,9.642h38.566a9.646,9.646,0,0,0,9.642-9.642V368.042a9.646,9.646,0,0,0-9.642-9.641H419.241a9.646,9.646,0,0,0-9.642,9.641Zm19.284-48.207h19.284V416.25H428.884Z",
    transform: "translate(53.195 46.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5173",
    "data-name": "Path 5173",
    d: "M48.208,307.2C.549,307.2,0,431.287,0,432.54a48.291,48.291,0,0,0,38.566,47.234v49.182a9.641,9.641,0,0,0,19.282,0V479.774A48.291,48.291,0,0,0,96.414,432.54C96.415,431.287,95.866,307.2,48.208,307.2Zm0,154.264A28.96,28.96,0,0,1,19.283,432.54c0-48.034,12.9-106.057,28.925-106.057S77.133,384.506,77.133,432.54A28.96,28.96,0,0,1,48.208,461.464Z",
    transform: "translate(0 39.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5174",
    "data-name": "Path 5174",
    d: "M99.408,256H60.841a9.645,9.645,0,0,0-9.641,9.641v19.284a9.641,9.641,0,0,0,19.282,0v-9.641H89.766v48.208a9.641,9.641,0,1,0,19.282,0V265.642A9.644,9.644,0,0,0,99.408,256Z",
    transform: "translate(6.649 33.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5175",
    "data-name": "Path 5175",
    d: "M419.241,230.733h38.566a9.645,9.645,0,0,0,9.642-9.641V163.242a9.645,9.645,0,0,0-9.642-9.641H419.241a9.645,9.645,0,0,0-9.642,9.641v57.849A9.645,9.645,0,0,0,419.241,230.733Zm9.642-57.849h19.284v38.566H428.884Z",
    transform: "translate(53.195 19.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5176",
    "data-name": "Path 5176",
    d: "M99.408,153.6H60.841a9.645,9.645,0,0,0-9.641,9.641V221.09a9.645,9.645,0,0,0,9.641,9.641H99.407a9.645,9.645,0,0,0,9.641-9.641V163.241A9.643,9.643,0,0,0,99.408,153.6Zm-9.642,57.85H70.484V172.884H89.767V211.45Z",
    transform: "translate(6.649 19.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5177",
    "data-name": "Path 5177",
    d: "M273.067,221.091a9.645,9.645,0,0,0,9.641,9.641h38.566a9.646,9.646,0,0,0,9.641-9.641V163.241a9.646,9.646,0,0,0-9.641-9.641H282.708a9.645,9.645,0,0,0-9.641,9.641Zm19.283-48.207h19.283v38.566H292.35Z",
    transform: "translate(35.463 19.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M517.874,102.4h-115.7a9.641,9.641,0,0,0,0,19.282H508.232V509.119a27.542,27.542,0,0,0-14.6-1.34,38.5,38.5,0,0,0-67.221,0,28.342,28.342,0,0,0-4.956-.434,28.925,28.925,0,1,0,0,57.849h77.13a28.96,28.96,0,0,0,28.924-28.924V112.041A9.645,9.645,0,0,0,517.874,102.4ZM498.59,545.912H421.457a9.641,9.641,0,0,1,0-19.283,9.532,9.532,0,0,1,5.226,1.572,9.642,9.642,0,0,0,14.617-5.929,19.207,19.207,0,0,1,37.448,0,9.642,9.642,0,0,0,14.617,5.929c6.276-4.05,14.867.906,14.867,8.07A9.658,9.658,0,0,1,498.59,545.912Z",
    transform: "translate(50.979 13.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5179",
    "data-name": "Path 5179",
    d: "M282.708,128.333h38.566a9.645,9.645,0,0,0,9.641-9.641V60.842a9.645,9.645,0,0,0-9.641-9.641H282.708a9.645,9.645,0,0,0-9.641,9.641v57.849A9.645,9.645,0,0,0,282.708,128.333Zm9.642-57.849h19.283v38.566H292.349Z",
    transform: "translate(35.463 6.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    "data-name": "Path 5180",
    d: "M273.067,323.49a9.645,9.645,0,0,0,9.641,9.642h38.566a9.646,9.646,0,0,0,9.641-9.642V265.641A9.646,9.646,0,0,0,321.274,256H282.708a9.645,9.645,0,0,0-9.641,9.641Zm19.283-48.207h19.283v38.566H292.35Z",
    transform: "translate(35.463 33.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    "data-name": "Path 5181",
    d: "M197.375,128.333h38.566a9.645,9.645,0,0,0,9.641-9.641V60.842a9.645,9.645,0,0,0-9.641-9.641H197.375a9.645,9.645,0,0,0-9.641,9.641v57.849A9.643,9.643,0,0,0,197.375,128.333Zm9.641-57.849H226.3v38.566H207.016Z",
    transform: "translate(24.381 6.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M250.262,412.382a9.643,9.643,0,1,0,13.692,0A10.139,10.139,0,0,0,250.262,412.382Z",
    transform: "translate(32.138 53.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M187.733,323.49a9.645,9.645,0,0,0,9.641,9.642h38.567a9.645,9.645,0,0,0,9.641-9.642V265.641A9.645,9.645,0,0,0,235.941,256H197.375a9.645,9.645,0,0,0-9.641,9.641V323.49Zm19.283-48.207H226.3v38.566H207.016Z",
    transform: "translate(24.381 33.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M170.667,368.041a9.645,9.645,0,0,0,9.641,9.642h28.925v86.773a9.641,9.641,0,1,0,19.282,0V377.683h77.133v86.773a9.641,9.641,0,1,0,19.282,0V377.683h28.925a9.641,9.641,0,1,0,0-19.283H180.308A9.645,9.645,0,0,0,170.667,368.041Z",
    transform: "translate(22.165 46.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5185",
    "data-name": "Path 5185",
    d: "M409.6,323.49a9.645,9.645,0,0,0,9.642,9.642h38.566a9.645,9.645,0,0,0,9.642-9.642V265.641A9.645,9.645,0,0,0,457.807,256H419.241a9.645,9.645,0,0,0-9.642,9.641Zm19.284-48.207h19.284v38.566H428.884Z",
    transform: "translate(53.195 33.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M396.855,0H146.175a9.645,9.645,0,0,0-9.641,9.641V511a9.641,9.641,0,1,0,19.282,0V19.282h231.4V511a9.641,9.641,0,0,0,19.282,0V9.641A9.644,9.644,0,0,0,396.855,0Z",
    transform: "translate(17.732)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabInmobiliario);
export default __webpack_public_path__ + "static/media/tab-inmobiliario.da654a16e04d9d7e643028905e1c7354.svg";
export { ForwardRef as ReactComponent };